import React from 'react';
import AnimatedElement from '../components/AnimatedElement.js';

const WhyMentorSection = () => (
    <section id="why-mentor" className="h-screen bg-brand-black text-brand-cream py-20 px-8 md:px-16 flex flex-col justify-around overflow-hidden">
        <div className="max-w-7xl mx-auto w-full">
         
        <AnimatedElement delay={500} type="fadeUp">
  <p className="block justify-center" style={{ fontFamily: 'pinar', color: '#ffd299',fontSize: "clamp(40px, 13vw, 170px)", lineHeight: "1"}}>WHO I AM</p>
</AnimatedElement>

<AnimatedElement delay={1000} type="fadeUp">
<p className="block justify-center" style={{ fontFamily: 'pinar', color: '#ffd299',fontSize: "clamp(40px, 13vw, 170px)", lineHeight: "1"}}>WHO I AM</p>
</AnimatedElement>

<AnimatedElement delay={1500} type="fadeUp">
<p className="block justify-center" style={{ fontFamily: 'pinar', color: '#ffd299',fontSize: "clamp(40px, 13vw, 170px)", lineHeight: "1"}}>WHO I AM</p>
</AnimatedElement>
           
        </div>
    </section>
);

export default WhyMentorSection;
